// import courseService from 'ApiService/Admin/courseService'; // Change this to the appropriate service
// import Card from 'components/card';
// import { AuthContext } from 'contexts/AuthContext';
// import { useContext, useState } from 'react';
// import toast from 'react-hot-toast';
// import StepperControl from 'views/admin/main/users/newUser/components/Admissions/StepperControl';
// import Stepper from 'views/admin/main/users/newUser/components/Stepper';
// import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
// import CourseInfo from './Steps/CourseInfo';
// import BatchInfo from './Steps/BatchInfo';
// import PrerequisiteInfo from './Steps/PrerequisiteInfo';
// import { deepConvertDatesForApi } from 'pages/helpers/convertDatesForApi';
// import ConfirmationModal from 'pages/Common/ConfirmationModal';

// const Index = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [disable, setDisable] = useState(true);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const { state } = useContext(AuthContext);
//   const selectedBranch = state?.selectedBranch || '';

//   const [formData, setFormData] = useState({
//     courseName: '',
//     department: '',
//     duration: '',
//     batches: [],
//     prerequisites: '',
//     certification: '',
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: ['courseName', 'department'].includes(name)
//         ? value.toLowerCase().replace(/\s+/g, ' ')
//         : value,
//     }));
//   };

//   const handleSubmit = async () => {
//     if (loading) return;
//     try {
//       setLoading(true);

//       const requiredFields = [
//         'courseName',
//         'department',
//         'duration',
//         'batches',
//         'prerequisites',
//         'certification',
//       ];

//       for (const field of requiredFields) {
//         if (
//           !formData[field] ||
//           (Array.isArray(formData[field]) && formData[field].length === 0)
//         ) {
//           toast.error(
//             `Please fill in ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}.`
//           );
//           setLoading(false);
//           return;
//         }
//       }

//       const dateFields = ['startDate', 'endDate'];

//       const formattedData = deepConvertDatesForApi(formData, dateFields);

//       const response = await courseService.createCourse({
//         ...formattedData,
//         selectedBranch,
//       });

//       if (response.data.success) {
//         toast.success(response.data.message);
//         setFormData({
//           courseName: '',
//           department: '',
//           duration: '',
//           batches: [],
//           prerequisites: '',
//           certification: '',
//         });
//         setCurrentStep(1);
//       } else {
//         toast.error(response.data.message);
//         setCurrentStep(1);
//       }
//     } catch (error) {
//       console.error('Frontend Error:', error);
//       toast.error(error.response.data.message);
//       setCurrentStep(1);
//     } finally {
//       setLoading(false);
//       setIsModalOpen(false);
//     }
//   };

//   const confirmCreation = () => {
//     setIsModalOpen(true);
//   };

//   const steps = [
//     { stepNo: 1, name: 'Course Info' },
//     { stepNo: 2, name: 'Batch Info' },
//     { stepNo: 3, name: 'Prerequisites & Certification' },
//   ];

//   const displayStep = (step) => {
//     switch (step.stepNo) {
//       case 1:
//         return (
//           <CourseInfo
//             handleChange={handleChange}
//             formData={formData}
//             setDisable={setDisable}
//           />
//         );
//       case 2:
//         return (
//           <BatchInfo
//             handleChange={handleChange}
//             formData={formData}
//             setDisable={setDisable}
//           />
//         );
//       case 3:
//         return (
//           <PrerequisiteInfo
//             handleChange={handleChange}
//             formData={formData}
//             setDisable={setDisable}
//           />
//         );
//       default:
//     }
//   };

//   const handleClick = (direction) => {
//     let newStep = currentStep;

//     direction === 'next' ? newStep++ : newStep--;
//     // check if steps are within bounds
//     newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
//   };

//   return (
//     <div className="md-mt-[3] mt-3 h-full w-full">
//       <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
//       <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3  3xl:w-7/12">
//         <div className="-mt-[280px] w-full pb-10 md:-mt-[340px] md:px-[70px]">
//           <Stepper steps={steps} currentStep={currentStep} />
//         </div>
//         <Card extra={'h-full mx-auto pb-3'}>
//           <div className="rounded-[20px]">
//             <UseContextProvider>
//               {displayStep(steps[currentStep - 1])}
//             </UseContextProvider>
//           </div>
//           <StepperControl
//             handleClick={handleClick}
//             currentStep={currentStep}
//             steps={steps}
//             loading={loading}
//             disable={disable || loading}
//             handleSubmit={confirmCreation}
//           />
//         </Card>
//       </div>
//       <ConfirmationModal
//         isOpen={isModalOpen}
//         onClose={() => {
//           if (!loading) setIsModalOpen(false);
//         }}
//         onConfirm={handleSubmit}
//         title="Confirm Course Creation"
//         message="Are you sure you want to create this course?"
//         confirmText={loading ? 'Processing...' : 'Yes, Create'}
//         cancelText="Cancel"
//         icon="info"
//         disableConfirm={loading}
//       />
//     </div>
//   );
// };

// export default Index;

import courseService from 'ApiService/Admin/courseService';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import StepperControl from 'views/admin/main/users/newUser/components/Admissions/StepperControl';
import Stepper from 'views/admin/main/users/newUser/components/Stepper';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import CourseInfo from './Steps/CourseInfo';
import BatchInfo from './Steps/BatchInfo';
import PrerequisiteInfo from './Steps/PrerequisiteInfo';
import { deepConvertDatesForApi } from 'pages/helpers/convertDatesForApi';
import ConfirmationModal from 'pages/Common/ConfirmationModal';

const Index = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { state } = useContext(AuthContext);
  const selectedBranch = state?.selectedBranch || '';

  // 🔥 UPDATED FORM DATA (GLOBAL SUPPORT)
  const [formData, setFormData] = useState({
    courseName: '',
    department: '',
    duration: '',
    batches: [],
    prerequisites: '',
    certification: false,
    isGlobal: false, // 🔥 NEW
  });

  // 🔄 Handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === 'checkbox'
          ? checked
          : ['courseName'].includes(name)
          ? value.toLowerCase().replace(/\s+/g, ' ')
          : value,
    }));
  };

  // 🚀 Submit course
  const handleSubmit = async () => {
    if (loading) return;

    try {
      setLoading(true);

      // ✅ Required fields validation
      const requiredFields = [
        'courseName',
        'department',
        'duration',
        'batches',
      ];

      for (const field of requiredFields) {
        if (
          !formData[field] ||
          (Array.isArray(formData[field]) && formData[field].length === 0)
        ) {
          toast.error(`Please fill ${field}`);
          setLoading(false);
          return;
        }
      }

      const dateFields = ['startDate', 'endDate'];
      const formattedData = deepConvertDatesForApi(formData, dateFields);

      // 🔥 BUILD PAYLOAD
      const payload = {
        ...formattedData,
        isGlobal: formData.isGlobal,
      };

      // 🔥 ONLY SEND BRANCH IF NOT GLOBAL
      if (!formData.isGlobal) {
        payload.branch = selectedBranch;
      }

      const response = await courseService.createCourse(payload);

      if (response.data.success) {
        toast.success(response.data.message);

        setFormData({
          courseName: '',
          department: '',
          duration: '',
          batches: [],
          prerequisites: '',
          certification: false,
          isGlobal: false,
        });

        setCurrentStep(1);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Frontend Error:', error);
      toast.error(error?.response?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
      setIsModalOpen(false);
    }
  };

  const confirmCreation = () => {
    setIsModalOpen(true);
  };

  const steps = [
    { stepNo: 1, name: 'Course Info' },
    { stepNo: 2, name: 'Batch Info' },
    { stepNo: 3, name: 'Prerequisites & Certification' },
  ];

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <CourseInfo
            handleChange={handleChange}
            formData={formData}
            setDisable={setDisable}
          />
        );
      case 2:
        return (
          <BatchInfo
            handleChange={handleChange}
            formData={formData}
            setDisable={setDisable}
          />
        );
      case 3:
        return (
          <PrerequisiteInfo
            handleChange={handleChange}
            formData={formData}
            setDisable={setDisable}
          />
        );
      default:
        return null;
    }
  };

  const handleClick = (direction) => {
    let newStep = currentStep;
    direction === 'next' ? newStep++ : newStep--;
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />

      <div className="mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <div className="-mt-[280px] w-full pb-10 md:-mt-[340px] md:px-[70px]">
          <Stepper steps={steps} currentStep={currentStep} />
        </div>

        <Card extra="h-full mx-auto pb-3">
          <UseContextProvider>
            {displayStep(steps[currentStep - 1])}
          </UseContextProvider>

          <StepperControl
            handleClick={handleClick}
            currentStep={currentStep}
            steps={steps}
            loading={loading}
            disable={disable || loading}
            handleSubmit={confirmCreation}
          />
        </Card>
      </div>

      {/* 🔥 CONFIRM MODAL */}
      <ConfirmationModal
        isOpen={isModalOpen}
        onClose={() => !loading && setIsModalOpen(false)}
        onConfirm={handleSubmit}
        title="Confirm Course Creation"
        message="Are you sure you want to create this course?"
        confirmText={loading ? 'Processing...' : 'Yes, Create'}
        cancelText="Cancel"
        icon="info"
        disableConfirm={loading}
      />
    </div>
  );
};

export default Index;
